import {useDispatch, useSelector} from "react-redux";
import {SORT_LIST_AFFILIATE_PERFORMANCE} from "../../utils/sort-list";
import {useFetch} from "../../services/useFetch";
import {API} from "../../services/api";
import {useEffect} from "react";
import {setToolsInitialState} from "../../reducers/tools.reducer";
import {useEffectAfterMount} from "../../services/useEffectAfterMount";
import AffiliatePerformanceList from "./affiliate-performance-list";
import AffiliatePerformanceFilter from "./affiliate-performance-filter";
import {setAffiliatePerformanceSelectedRowKeys} from "../../reducers/affiliate.reducer";

const AffiliatePerformancePage = () => {
    const dispatch = useDispatch()
    const defaultSort = SORT_LIST_AFFILIATE_PERFORMANCE?.find(item => item.isDefault)
    const getOrderBy = defaultSort?.key.split('_')
    const {
        currentPage,
        pageSize,
        orderBy,
        sort,
        searchKey,
        reload
    } = useSelector(state => state.toolsReducer)
    const queryParams = {
        page: currentPage,
        perPage: pageSize,
        orderBy: !!orderBy ? orderBy : getOrderBy[0],
        orderType: sort,
        search: searchKey,
    }
    const {
        data: response,
        fetching: getAffiliatePerformanceList,
        isLoading
    } = useFetch(API.AFFILIATE_PERFORMANCE_LIST, queryParams, {isWithTotalData: true})


    useEffect(() => {
        return () => {
            dispatch(setToolsInitialState())
            dispatch(setAffiliatePerformanceSelectedRowKeys([]))
        }
    }, [])

    useEffectAfterMount(() => {
        getAffiliatePerformanceList()
    }, [currentPage, pageSize, orderBy, sort, searchKey, reload])


    return (
        <div className={"col px-10"}>
            <AffiliatePerformanceFilter/>
            <AffiliatePerformanceList dataSource={response?.data?.result ?? []} isLoading={isLoading}/>
        </div>
    )
}

export default AffiliatePerformancePage
